import Service from "./Service"
import {getCompanyCookie, checkIfLocaleIsCSE} from "@/utils/utils"


export default class SearchEngineService extends Service {

    constructor() {
        super()
        this.serviceUrl = `https://api.travelski.com/se`
        // this.serviceUrl = `https://api-migdal.travelfactory.fr/dev/se`
        this.mandatoryFields = {
            "getStartDates": ['liheId', 'packCode', 'month', 'locale'],
            "getEndDates": ['liheId', 'packCode', 'month', 'startDate', 'locale'],
            "getAvailabilities": ["locale", "packCode", "liheId", "season"],
            "getLiheNearbyData": ["locale"],
        }
    }


    async getStartDates(requestData) {
        this.checkMandatoryFields(requestData, "getStartDates")
        const {liheId, packCode, month, locale} = requestData
        const headers = {"accept-language": locale.replace("_", "-")}
        const params = {
            liheId, 
            packCode, 
            month, 
            ...(checkIfLocaleIsCSE(locale) && {company: getCompanyCookie()})
            
        }
        const url = `${this.serviceUrl}/planning/monthavailabilities/start`
        const {data} = await this.axios.get(url, {params, headers})
        return data
    }


    async getEndDates(requestData) {
        this.checkMandatoryFields(requestData, "getEndDates")
        const {liheId, packCode, month, locale, startDate} = requestData
        const headers = {"accept-language": locale.replace("_", "-")}

        const params = {
            liheId, 
            packCode, 
            month, 
            startDate, 
            ...(checkIfLocaleIsCSE(locale) && {company: getCompanyCookie()})
        }
        const url = `${this.serviceUrl}/planning/monthavailabilities/end`
        const {data} = await this.axios.get(url, {params, headers})
        return data
    }

    async getAvailabilities(requestData) {
        this.checkMandatoryFields(requestData, "getAvailabilities")
        const {locale, packCode, liheId, season, startDate, endDate} = requestData
        const headers = {"accept-language": locale.replace("_", "-")}
        const params = {
            packCode, 
            liheId, 
            season,
            startDate, 
            endDate, 
            ...(checkIfLocaleIsCSE(locale) && {company: getCompanyCookie()})
        }

        const url = `${this.serviceUrl}/planning/availabilities/`
        const {data} = await this.axios.get(url, {headers, params})
        return data
    }

    async getLiheNearbyData(requestData, payload, size = 20) {
        this.checkMandatoryFields(requestData, "getLiheNearbyData")
        const headers = {"content-type": "application/json", "accept-language": requestData.locale.replace("_", "-")}
        const {locale} = requestData
        const params = {
            size: requestData.size || size,
            ...(checkIfLocaleIsCSE(locale) && {company: getCompanyCookie()})
        }
        const body = JSON.stringify(payload)
        const url = `${this.serviceUrl}/search/product/map`
        const {data} = await this.axios.post(url, body, {headers, params})
        return data
    }
}


